export default {
    lotteryQr: '抽奖二维码',
    checkResult: '查看结果需',
    downloadApp: '下载APP',
    prize: '奖品',
    introTitle: '如何抽奖、兑奖',
    lotteryRule: '抽奖规则',
    checkDetailsHint: '（点击查看详情）',
    addCardHint1: '添加您的',
    addCardHint2: '卡片到Laidan',
    howGetCard: '如何获取您的卡片',
    getCardText: '您可以通过免费的移动应用程序Laidan',
    flowTitle1: '下载Laidan',
    flowText1: '假如你没有Laidan，你可以用它来让你的钱包瘦身',
    flowTitle2: '添加您的卡片',
    flowText2: '一旦你安装了Laidan，点击这个按钮将卡添加到应用程序！',
    flowTitle3: '全部完成！',
    flowText3: '享受您改进后的移动购物体验！',
    flowBtnText1: '去获得',
    flowBtnText2: '下载从',
    flowBtnText3: '添加到',
    merchantOs: '您自己的商家系统',
    howCreateOs: '如何创建您的系统',
    createOsText: '您可以通过免费的移动应用程序Joinku管理你的货物和创建会员系统',
    kuTitle1: '下载Joinku',
    kuText1: '假如你没有Joinku，你可以用它来节约你宝贵的时间！',
    kuTitle2: '查看您的系统',
    kuText2: '一旦你安装了Joinku，点击这个按钮查看会员和订单！',
    kuTitle3: '全部完成！',
    kuText3: '享受您改进后的系统管理体验！',
    taxExpert: '您的电子税票专家',
    howGetTax: '如何获得您的电子税票',
    getTaxText: '您可以通过免费的移动应用程序Laidan接收您的电子税票和参与商家抽奖等',
    danTitle1: '下载Laidan',
    danText1: '假如你没有Laidan，你可以用它来让你享受更多优惠！',
    danTitle2: '浏览您的活动',
    danText2: '一旦你安装了 Laidan，点击这个按钮参与您的优惠！',
    danText3: '享受您改进后的移动优惠体验！',
    inviteCashDedu: '邀请得现金抵扣',
    inviteCode: '邀请码',
    copyInviteCode: '点击可复制邀请码！',
    copySucceed: '复制成功！',
    copyError: '复制失败！',
    memberSystem: '会员系统',
    memberSystemText: '每邀请1位新用户使用您的邀请码注册成为Joinku用户，即可获得100€年费抵扣',
    inviteTitle2: '设置邀请码',
    inviteText2: '一旦你安装了Joinku，先复制邀请码再点击这个按钮前往Joinku！',
    inviteText3: '获得年费现金抵扣！',
    flowBtnText4: '去看看',
    phoneLabel: '电话：',
    addressLabel: '地址：',
    readAndAccept: '阅读并接受',
    privacyPolicy: '隐私政策',
    startLottery: '开始抽奖',
    usePhoneLogin: '通过手机号登录',
    useEmailLogin: '通过邮箱登录',
    phoneLogin: '手机号登录',
    countryCodeSearch: '输入国家名称、区号搜索',
    emailLogin: '邮箱登录',
    getAuthCode: '获取验证码',
    inpPhoneHint: '请输入手机号码',
    inpEmailHint: '请输入邮箱账号',
    inpAuthCode: '请输入验证码',
    codeVerifyTitle: '请完成安全校验',
    codeVerifyHint: '向右滑动完成校验',
    verifyError: '校验失败',
    verifyFinish: '校验完成',
    login: '登录',
    clickCheck: '点开看看',
    downAppPrize: '下载APP查看奖品',
    lottoErrorHint: '抽奖码错误',
    lottoNoloHint: '未开奖请耐心等待',
    lottoNowiHint: '很遗憾未中奖',
    lottoWinnHint: '恭喜您中奖啦 !!!',
    lottoUsedHint: '此抽奖码已被使用',
    partPlatLotto: '欢迎参与平台抽奖',
    skipPlatLotto: '后自动跳转至平台抽奖页面',
    skipPrize: '后自动跳转至奖品页面',
    allowMerRead: '允许商家获取我的信息：',
    infoMore: '姓名、电话、生日',
    joinMember: '加入会员',
    checkMember: '查看会员',
    drawPlatCoupon: '领取平台优惠券',
    moreDisDis: '更多折扣优惠',
    firLoginDraw: '首次登陆APP可获得',
    clickDown: '点击下载',
    appDraw: 'APP领取',
    validTime: '有效期至',
    useAwaCodeHint: '请在下次就餐时使用，在结账时出示条形码',
    platLottoCode: '平台抽奖码',
    lottoCode: '抽奖码：',
    lotteryTime: '开奖时间：',
    noLottery: '未开奖',
    yetWinning: '已中奖',
    noWinning: '未中奖',
    haveUsed: '已使用',
    sellOut: '售罄',
    currentPrice: '时价',
    includeAllergen: '含有过敏源',
    details: '详情',
    selectAllergen: '选择过敏源',
    rawMaterials: '原材料：',
    cookingWay: '制作方式：',
    allergens: '含有过敏源：',
    mayAddMaterials: '可增加原材料：',
    mayMinusMaterials: '可删减原材料：',
    taste: '口味偏好：',
    selectedGroupNum: '已选菜品数：',
    priceZero: '价格为0的菜品',
    priceNoZero: '价格不为0的菜品',
    notSetMealDishes: '此套餐下没有菜品',
    notGroupDishes: '此分类下没有菜品',
    notDishesMat: '此菜品下没有原材料',
    notGroupMat: '此分类下没有原材料',
    selectFinish: '已选完',
    noSelectFinish: '未选完',
    cancel: '取消',
    woka: {
        activityPage: '活动页面',
        unlockDish: '免费解锁菜品',
        unlockText: '按照活动规则参与分享活动即可免费解锁任意一道菜品！',
        activityRule: '活动规则',
        ruleText: '任意选择以下一种方式,完成后上传截图到指定位置即可获得菜品兑换码',
        issueWork: '发布作品',
        weChat: '微信',
        wechatText: '分享到朋友圈，集满20个好友点赞',
        douyinText1: '1.参与话题 #AI智能厨房助手#',
        douyinText2: '2.评论置顶',
        douyinText3: '3.发布抖音 @xxxx',
        redBook: '小红书',
        redBookText2: '2.标记所在位置',
        instagramText1: '1.发布公开的快拍+帖子/Reels',
        instagramText2: '2.@提醒3个朋友',
        tikTokText1: '1.限时动态',
        tikTokText2: '2.公开的作品@提及3个朋友',
        partActivity: '参与活动',
    }
};
